import React from 'react';
import styles from './UnderConstruction.module.css';

/**
 * UnderConstruction
 * A reusable placeholder for pages/features that are not built yet.
 * Props:
 * - title?: string | ReactNode (default: 'Under Construction')
 * - message?: string | ReactNode (default: 'This section is currently being built. Check back soon!')
 * - icon?: ReactNode (default: a wrench emoji)
 * - children?: ReactNode (extra content rendered below the message)
 * - className?: string
 * - style?: React.CSSProperties
 */
export function UnderConstruction({
  title = 'Under Construction',
  message = 'This section is currently being built. Check back soon!',
  icon,
  children,
  className,
  style,
  ...rest
}) {
  const classes = [styles.wrapper];
  if (className) classes.push(className);

  return (
    <div className={classes.join(' ')} style={style} {...rest}>
      <div className={styles.icon} aria-hidden="true">
        {icon || '🛠️'}
      </div>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.message}>{message}</p>
      {children && <div className={styles.content}>{children}</div>}
    </div>
  );
}
